import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Page from "../../components/general/page";
import SchedaCliente from "../../components/schedaCliente";
import CustomAlert from "../../components/general/customAlert";

import { findStatistics } from "../../store/actions/statistics";
import { getKpiList, getKpiTitles, getCredits, getRevenues, getObligations, isBusinessPerformanceActive } from "../../store/actions/analytics/index";
import { injectIntl } from "react-intl";
import { FEATURE_TOGGLE_TSPAY_ONBOARDING } from "../../config";
import TsPayOnboardingToast from "../../components/tspay/onboarding/onboardingToast";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils";

const CustomerFormView = (props) => {
  const { intl, pageRef } = props;

  const dispatch = useDispatch();
  const company = useSelector((state) => state.company);
  const auth = useSelector((state) => state.auth);
  const main = useSelector((state) => state.main);
  const user = useSelector((state) => state.user);
  const services = useSelector((state) => state.servicesAgyo);

  const accountantIdSelected = main.accountantIdSelected;
  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;
  const tsPayConfig = useSelector((state) => state.tspay.configStatus);
  const onBoardingData = tsPayConfig?.data;
  /* const onBoardingData = {
    itemId: "6e9053c3-5f3d-4864-bc59-954cd6672d92",
    merchantRef: "ADLVH75CDM",
    onboardingSessions: ["AAA", "DDD"],
    status: "NOT_LINKED",
    createdAt: "1970-01-01T00:00:00.000+00:00",
    updatedAt: "1970-01-01T00:00:00.000+00:00",
  }; */
  const onBoardingStatus = onBoardingData?.status;
  const isToastToShow =
    onBoardingStatus === "NOT_LINKED" ||
    onBoardingStatus === "ONBOARDING"; /* ||
    (onBoardingStatus === "TO_BE_CONFIRMED" && onBoardingData?.onboardingSessions.length !== 0); */
  const isToBeConfirmedStatus = onBoardingStatus === "TO_BE_CONFIRMED";

  const myType = main.myType;

  const studioFind = GetSelectedCompanyStudio();

  useEffect(() => {
    dispatch(isBusinessPerformanceActive());
    dispatch(findStatistics(
      auth, clientIdSelected, accountantIdSelected
    ));
    dispatch(getKpiList());
    dispatch(getKpiTitles());
    dispatch(getCredits());
    dispatch(getRevenues());
    dispatch(getObligations());
  }, [clientIdSelected, accountantIdSelected]);

  let allCompanyServices = {};
  let allAccountantServices = {};
  let customerHasTSPay = false;
  let accountantHasTSPay = false;
  let showToastActiveTSPay = false;
  if (!services?.allCompanyServices.status.started && services?.allCompanyServices.status.ended && services?.allCompanyServices?.status?.list) {
    allCompanyServices = services?.allCompanyServices.status.list;
  }
  for (let service in allCompanyServices) {
    if (
      allCompanyServices[service] &&
      (allCompanyServices[service].id === "TSPAY" || allCompanyServices[service].id === "BANKLINK-INFO" || allCompanyServices[service].id === "BANKLINK-POST")
    ) {
      customerHasTSPay = true;
    }
  }

  if (!services?.allAccountantServices.status.started && services?.allAccountantServices.status.ended && services?.allAccountantServices?.status?.list) {
    allAccountantServices = services?.allAccountantServices.status.list;
  }
  for (let service in allAccountantServices) {
    if (
      allAccountantServices[service] &&
      (allAccountantServices[service].id === "TSPAY" ||
        allAccountantServices[service].id === "BANKLINK-INFO" ||
        allAccountantServices[service].id === "BANKLINK-POST")
    ) {
      accountantHasTSPay = true;
    }
  }

  if (accountantHasTSPay && !customerHasTSPay) {
    showToastActiveTSPay = true;
  }

  if (!companySelected) return null;
  let ragioneSociale = company.companies.find((el) => {
    return el.codiceFiscale === companySelected;
  }).ragioneSociale;

  const renderTsPayOnboardingToast = () => {
    if ((showToastActiveTSPay || (accountantHasTSPay && customerHasTSPay && isToastToShow)) && FEATURE_TOGGLE_TSPAY_ONBOARDING === "true") {
      return (
        <TsPayOnboardingToast
          myType={myType}
          auth={auth}
          itemId={main.companyUuidSelected}
          onBoardingStatus={onBoardingStatus}
          onBoardingData={onBoardingData}
          isToBeConfirmedStatus={isToBeConfirmedStatus}
        />
      );
    }
    return undefined;
  };

  return (
    <Page
      pageRef={pageRef}
      className={"contentStructure"}      
      title={intl.formatMessage({ id: "customerPage.title" })}
      subtitle={ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + companySelected}
      topHeaderContent={
        showToastActiveTSPay && !onBoardingStatus && studioFind?.taxRegion !== "ES" && user?.profile?.language !== "es-ES" ? (
          <CustomAlert            
            msg1="customerPage.landing.tsPayAlertMsg1"
            buttonText="dashboard.showMore"
            connectionsText="customerPage.landing.tsPayConnectionsButton"
            isTsPayOnboarding={false}
            isTsPayPackage={true}
            buttonLink={""}
          />
        ) : (
          renderTsPayOnboardingToast()
        )
      }
      /* topHeaderContent={
        showToast ? <CustomAlert          
          msg1="customerPage.landing.tsPayAlertMsg1"
          buttonText="dashboard.showMore"
          connectionsText="customerPage.landing.tsPayConnectionsButton"
          isTsPayOnboarding={false}
          isTsPayPackage={true}
          buttonLink={""}
        /> : null
      } */
    >
      {myType === "STUDIO" ? <SchedaCliente /> : null}
    </Page>
  );
};

export default injectIntl(CustomerFormView);
